'use strict';

// I'll need to fix first 'isomorphic-fetch' to be transpiled using
// babel-runtime before remove this line of code.

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('core-js/es6/promise');

var log = require('../utils/logger')('splitio-client');
var Engine = require('../engine');

var TimeTracker = require('../tracker/Timer');
var PassTracker = require('../tracker/PassThrough');

var thenable = require('../utils/promise/thenable');

var _require = require('../utils/key/factory'),
    matching = _require.matching,
    bucketing = _require.bucketing;

var LabelsConstants = require('../utils/labels');

function getTreatmentAvailable(evaluation, changeNumber, settings, splitName, key, stopLatencyTracker, impressionsTracker) {
  var matchingKey = matching(key);
  var bucketingKey = bucketing(key);

  var treatment = evaluation.treatment;

  var label = undefined;

  if (evaluation.treatment !== 'control') {
    log.info('Split: ' + splitName + '. Key: ' + matchingKey + '. Evaluation: ' + treatment);
  } else {
    log.warn('Split ' + splitName + ' doesn\'t exist');
  }

  if (settings.core.labelsEnabled) label = evaluation.label;

  stopLatencyTracker();

  impressionsTracker({
    feature: splitName,
    keyName: matchingKey,
    treatment: treatment,
    time: Date.now(),
    bucketingKey: bucketingKey,
    label: label,
    changeNumber: changeNumber
  });

  return evaluation.treatment;
}

function splitObjectAvailable(splitObject, splitName, key, attributes, stopLatencyTracker, impressionsTracker, settings, storage) {
  var evaluation = {
    treatment: 'control',
    label: LabelsConstants.SPLIT_NOT_FOUND
  };
  var changeNumber = undefined;

  if (splitObject) {
    var split = Engine.parse(JSON.parse(splitObject), storage);

    evaluation = split.getTreatment(key, attributes);
    changeNumber = split.getChangeNumber(); // Always sync and optional

    // If the storage is async, evaluation and changeNumber will return a
    // thenable
    if (thenable(evaluation)) {
      return evaluation.then(function (result) {
        return getTreatmentAvailable(result, changeNumber, settings, splitName, key, stopLatencyTracker, impressionsTracker);
      });
    }
  }

  return getTreatmentAvailable(evaluation, changeNumber, settings, splitName, key, stopLatencyTracker, impressionsTracker);
}

function ClientFactory(settings, storage) {
  var latencyTracker = TimeTracker(storage.metrics);
  var impressionsTracker = PassTracker(storage.impressions);

  return {
    getTreatment: function getTreatment(key, splitName, attributes) {
      var stopLatencyTracker = latencyTracker('getTreament');
      var splitObject = storage.splits.getSplit(splitName);

      if (thenable(splitObject)) {
        return splitObject.then(function (result) {
          return splitObjectAvailable(result, splitName, key, attributes, stopLatencyTracker, impressionsTracker, settings, storage);
        });
      }

      return splitObjectAvailable(splitObject, splitName, key, attributes, stopLatencyTracker, impressionsTracker, settings, storage);
    },
    getTreatments: function getTreatments(key, splitNames, attributes) {
      var _this = this;

      var results = {};
      var thenables = [];
      var i = void 0;

      var _loop = function _loop() {
        var name = splitNames[i];
        // If we are on the browser, key was binded to the getTreatment method.
        var treatment = _this.isBrowserClient ? _this.getTreatment(name, attributes) : _this.getTreatment(key, name, attributes);

        if (thenable(treatment)) {
          // If treatment returns a promise as it is being evaluated, save promise for progress tracking.
          thenables.push(treatment);
          treatment.then(function (res) {
            // set the treatment on the cb;
            results[name] = res;
          });
        } else {
          results[name] = treatment;
        }
      };

      for (i = 0; i < splitNames.length; i++) {
        _loop();
      }

      if (thenables.length) {
        return _promise2.default.all(thenables).then(function () {
          // After all treatments are resolved, we return the mapping object.
          return results;
        });
      } else {
        return results;
      }
    }
  };
}

module.exports = ClientFactory;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/client/client.js
// module id = 1176
// module chunks = 0